export const getSafeRedirectPath = (redirect, fallback = "/") => {
    if (!redirect || typeof redirect !== "string" || !redirect.startsWith("/")) {
        return fallback
    }

    try {
        const origin = window.location.origin
        const target = new URL(redirect, origin)

        if (target.origin !== origin || target.pathname === "/login") {
            return fallback
        }

        return `${target.pathname}${target.search}${target.hash}`
    } catch (err) {
        return fallback
    }
}

export const getRedirectFromSearch = (search, fallback = "/") => {
    const searchParams = new URLSearchParams(search)
    return getSafeRedirectPath(searchParams.get("redirect"), fallback)
}
